import { Component, ComponentInterface, h, Prop, VNode } from '@stencil/core';

import { UniHostTemplate } from '@uiwebkit/common';
import { uniWatermark } from '@uni/license';

@Component({ tag: 'uni-layout-col' })
export class UniLayoutColComponent implements ComponentInterface {

  @Prop({ reflect: true }) breakpoint: 'xs' | 'sm' | 'md' | 'lg' | 'xl';

  @Prop({ reflect: true }) col: number;

  render(): VNode {
    const xs = this.col ? `col-xs-${this.col}` : 'col-xs';
    const sm = this.col ? `col-sm-${this.col}` : 'col-sm';
    const md = this.col ? `col-md-${this.col}` : 'col-md';
    const lg = this.col ? `col-lg-${this.col}` : 'col-lg';
    const xl = this.col ? `col-xl-${this.col}` : 'col-xl';

    const classes = {
      'col': !this.breakpoint,
      [xs]: this.breakpoint === 'xs',
      [sm]: this.breakpoint === 'sm',
      [md]: this.breakpoint === 'md',
      [lg]: this.breakpoint === 'lg',
      [xl]: this.breakpoint === 'xl'
    };

    return UniHostTemplate({ classes }, <slot/>);
  }

  componentDidLoad(): void {
    uniWatermark('pro');
  }
}
